import React from 'react'
import { AlertVariant } from 'components/styled/alert/context'
import { Icon } from 'components/styled/icon'
import styled from 'styled-components'
import { ThemeColor } from 'theme/colors'

const getColor = (variant: AlertVariant): ThemeColor => {
  switch (variant) {
    case 'error':
      return 'error110'
    case 'info':
      return 'secondary110'
    case 'warn':
      return 'warn110'
    case 'success':
    default:
      return 'success110'
  }
}

const getBackgroundColor = (variant: AlertVariant): ThemeColor => {
  switch (variant) {
    case 'error':
      return 'error05O75'
    case 'info':
      return 'secondary05O75'
    case 'warn':
      return 'warn05O75'
    case 'success':
    default:
      return 'success05O75'
  }
}

export const getIcon = (variant: AlertVariant): string => {
  switch (variant) {
    case 'error':
      return 'error'
    case 'info':
      return 'help'
    case 'warn':
      return 'warning'
    case 'success':
    default:
      return 'check_circle'
  }
}

const IconWrapper = styled.div<{
  variant: AlertVariant
  flippedView?: boolean
}>`
  padding: ${({ theme }) => theme.space.s12};
  margin: ${({ theme, flippedView }) =>
    flippedView ? `0 0 0 ${theme.space.s24}` : `0 ${theme.space.s24} 0 0`};

  border-radius: ${({ theme }) => theme.space.s20};

  align-self: flex-start;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;

  color: ${({ theme, variant }) => theme.color[getColor(variant)]};
  background-color: ${({ theme, variant }) =>
    theme.color[getBackgroundColor(variant)]};
`

export const AlertIcon = ({
  variant,
  flippedView = false,
}: {
  variant: AlertVariant
  flippedView?: boolean
}) => {
  return (
    <IconWrapper variant={variant} flippedView={flippedView}>
      <Icon type={getIcon(variant)} size="s16" />
    </IconWrapper>
  )
}
